import { REQUESTED, SUCCESS, FAILED, HTTP_ACTION } from '../constants';
import { IS_ENABLE_RSA } from './../constants/index';
export const httpMiddleware = store => next => action => {
  if (action[HTTP_ACTION]) {
    const actionInfo = action[HTTP_ACTION];
    let initialState = actionInfo.initialStates;
    let fetchOptions = {
      method: actionInfo.verb,
      headers: actionInfo.headers,
      response: actionInfo.response,
      initialState
    };
    if (IS_ENABLE_RSA ) {
    //VAPT task: encryption of user details in login action
    if( IS_ENABLE_RSA && actionInfo.type === 'LOGIN'){
  		       fetchOptions = {
  		         ...fetchOptions,
  		         user: actionInfo.user
  		       };
  	}
  }
    if (actionInfo.verb !== 'GET') {
      fetchOptions.body = actionInfo.response || null
    }
    next({
      type: actionInfo.type
    });
    fetch(actionInfo.endpoint, fetchOptions)
      .then(handleErrors)
      .then(response => response.json())
      .then(data => { 
        if (data.status == 'success') {
          //VAPT task: Encryption of user details in login action
          let resDet=(IS_ENABLE_RSA && actionInfo.type === 'LOGIN')?fetchOptions.user :actionInfo.response;
          next({
  		             type: actionInfo.type + '_SUCCESS',
  		             result: data,
  		             response: resDet,
  		             initialState
  		           })

        } else {
          next({
            type: actionInfo.type + '_FAILURE',
            result: data,
            response: actionInfo.user,
            initialState
          })
        }
      })
      .catch(error => {
        next({
          type: actionInfo.type + '_FAILURE',
          result: error.data || {message : error.message}, // vulnerabilty reset pwd changes
          initialState
        })
      });
  } else {
    return next(action);
  }
}
function handleErrors(response) {
  if (!response.ok) { // vulnerabilty reset pwd changes
    return response.json().then(err => {
      const error = new Error(err.message || response.statusText);
      error.status = response.status;
      error.data = err;
      throw error;
    });
  }
  return response;
}
